import { GetterTree } from 'vuex';

import {
  EventStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<EventStateI, RootStateI> = {
};
